import { render, staticRenderFns } from "./CollectionRecord.vue?vue&type=template&id=78ebeb11&scoped=true"
import script from "./CollectionRecord.vue?vue&type=script&lang=js"
export * from "./CollectionRecord.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecord.vue?vue&type=style&index=0&id=78ebeb11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ebeb11",
  null
  
)

export default component.exports